import type { FleetUnitVehicle } from '@chukua/common';
import { RigTyresTab } from '../../../../maintenance/features/tyres/public/RigTyresTab';
import { VehicleTyresTab } from '../../../../maintenance/features/tyres/public/VehicleTyresTab';

interface UnitTyresTabProps {
  truck: FleetUnitVehicle;
  trailer: FleetUnitVehicle | null;
}

/** A unit's tyres: the truck and the trailer it pulls on one drawing (gitaumoses4/chukua#390), or the truck alone when it pulls none. */
export function UnitTyresTab({ truck, trailer }: UnitTyresTabProps) {
  if (!trailer) return <VehicleTyresTab vehicleKind="truck" vehicleId={truck.id} />;
  return <RigTyresTab key={trailer.id} truckId={truck.id} trailerId={trailer.id} />;
}
